import { useState } from "react";
import { AlgoliaSearchResponse } from "../../../../data-model/algoliaSearchModel";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";

export interface MyMedicalPaOrdersState {
  data?: AlgoliaSearchResponse;
  loading?: boolean;
  error?: string;
  showinLineLoader?: boolean;
  totalCount?: number;
}
export const useMyPaOrdersTableData = () => {
  const [tableData, setTableData] = useState<MyMedicalPaOrdersTableData[]>([]);
  const [myMedicalPaOrdersState, setMyMedicalPaOrdersState] =
    useState<MyMedicalPaOrdersState>({
      data: undefined,
      loading: false,
      error: undefined,
      showinLineLoader: false,
    });

  return {
    myMedicalPaOrdersState,
    setMyMedicalPaOrdersState,
    tableData,
    setTableData,
  };
};
